import BillingsCargoTaxiBulkUpdateStatusRequest, {
  BillingsCargoTaxiBulkUpdateStatusRequestBillingStatus,
} from "../../../../api/raily/billings/cargo-taxi/bulk-update-status/billings-cargo-taxi-bulk-update-status.request";
import BillingStatus from "../../../../types/billing-status";
import BillingsCargoTaxiBulkUpdateStatusParams from "./billings-cargo-taxi-bulk-update-status-params";

const createStatus = (
  status: BillingStatus,
): BillingsCargoTaxiBulkUpdateStatusRequestBillingStatus => {
  switch (status) {
    case BillingStatus.CREATED:
      return BillingsCargoTaxiBulkUpdateStatusRequestBillingStatus.CREATED;
    case BillingStatus.ACCEPTED:
      return BillingsCargoTaxiBulkUpdateStatusRequestBillingStatus.ACCEPTED;
    case BillingStatus.REJECTED:
      return BillingsCargoTaxiBulkUpdateStatusRequestBillingStatus.REJECTED;
    case BillingStatus.REOPEN_REQUEST:
      return BillingsCargoTaxiBulkUpdateStatusRequestBillingStatus.REOPEN_REQUEST;
    case BillingStatus.REOPENED:
      return BillingsCargoTaxiBulkUpdateStatusRequestBillingStatus.REOPENED;
  }
};

const create = (
  params: BillingsCargoTaxiBulkUpdateStatusParams,
): BillingsCargoTaxiBulkUpdateStatusRequest => {
  return {
    billingIds: params.billingIds,
    status: createStatus(params.status),
    comment: params.comment,
  };
};

const billingsCargoTaxiBulkUpdateStatusParamsFactory = {
  create,
};

export default billingsCargoTaxiBulkUpdateStatusParamsFactory;
